const WCS = {
  getDescribeCoverageNilValue: async (datasetName) => {
    let response = await fetch(
      `https://sparcal.sdsc.edu/geoserver/wcs?service=WCS&version=2.0.1&request=DescribeCoverage&coverageId=${datasetName}`,
      {
        method: 'GET',
      }
    )
      .then((response) => response.text()) // Get raw XML as string
      .then((xmlString) => {
        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(xmlString, 'application/xml');
        // Define the namespace resolver
        const nsResolver = (prefix) => {
          const ns = {
            swe: 'http://www.opengis.net/swe/2.0',
          };
          return ns[prefix] || null;
        };

        // Evaluate XPath to find the <swe:nilValue>
        const xpath = '//swe:nilValue';
        const result = xmlDoc.evaluate(
          xpath,
          xmlDoc,
          nsResolver,
          XPathResult.FIRST_ORDERED_NODE_TYPE,
          null
        );
        const nilValueNode = result.singleNodeValue;

        if (nilValueNode) {
          //   console.log('NilValue:', nilValueNode.textContent);
          //   console.log('Reason:', nilValueNode.getAttribute('reason'));
          return nilValueNode.textContent;
        } else {
          return null;
        }
      })
      .catch((error) => {
        console.error('Fetch error:', error);
      });
    return response;
  },
  getWcsClipping: async (wcsData, feature_value) => {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/Utility/wcs/clip`,
      {
        method: 'POST',
        headers: {
          Accept: '*/*',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          geoserver_url: wcsData.url, //wcs url
          coverage_id: wcsData.wcs_coverage_id, // wcs id
          geojson: feature_value,
          input_crs: 'EPSG:3310', // Projection is always 3310 since when the layers are added to they are the map in this projection.
          output_format: 'image/tiff',
          wcs_crs: 'EPSG:3310',
          zip_filename: wcsData.wcs_coverage_id,
        }),
      }
    );
    return response;
  },
};
export default WCS;
